<template>
    <main class="py-12 space-y-12">
        <SectionsSectionIntro
            :images="sectionIntro.images"
            :title="sectionIntro.title"
            :teaser="sectionIntro.teaser"
            :text="sectionIntro.text"
        />

        <section class="container lg:pt-16">
            <div class="lg:columns-2 gap-8">
                <h2>
                    Unser Holz
                </h2>
                <p class="article-teaser">
                    Unserer Umwelt zuliebe greifen wir auf den nachwachsenden Rohstoff Holz zurück.
                </p>
                <p>
                    Holz, das wir aus den heimischen, nachhaltig bewirtschafteten Forsten beziehen und bis zur
                    Verfeuerung der Schnittabfälle komplett verwerten. Wir verwenden ausschließlich Hölzer aus PEFC/FSC
                    zertifizierten Waldbeständen!
                </p>
                <p>
                    Wegen ihrer überragenden Eigenschaften verarbeiten wir hauptsächlich Hölzer aus kerngetrennter und
                    naturbelassener Douglasie. Sie härtet hervorragend aus, ist resistent, hat herausragende statische
                    Eigenschaften und lässt sich sehr gut form- und kraftschlüssig verarbeiten.
                </p>
                <p>
                    Die Auswahl der einzuschlagenden Bäume erfolgt durch unsere qualifizierten Holzmeister gemeinsam mit
                    den Forstwirten. Dadurch gewährleisten wir eine gleichbleibende Qualität der Hölzer und minimieren
                    Ausschuss und Verschnitt schon vor dem Einschlag der Bäume.
                </p>
            </div>
        </section>

        <section class="container">
            <div class="grid lg:grid-cols-5 gap-12">
              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="wintereingeschlagene_Hoelzer.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                    <h2>
                        Wir verwenden nur wintereingeschlagene Hölzer für beste Qualität!
                    </h2>
                    <p>
                        Bäume werden am besten zwischen Dezember und Anfang Februar gefällt. Dann fließt in den Adern
                        weniger Wasser als während der Wachstumsperiode und es sind geringere Mengen an Mineralien
                        vorhanden. Durch die geringere Winterholzfeuchte und Freiluftlagerung verläuft der
                        Trocknungsvorgang schonender als beim Sommereinschlag mit Kammertrocknung.
                    </p>
                </div>

                <div class="lg:col-span-3">
                    <h2>
                        Schrauben und Verbindungen
                    </h2>
                    <p>
                        Alle Holzschrauben werden in V2A-Edelstahl verbaut. Statisch hoch beanspruchte Verbindungen sind
                        durchgehend verschraubt und werden aufgrund der höheren Festigkeit mit verzinkten Schrauben 8.8
                        ausgeführt. Die Schraubenköpfe werden durch spezielle Kappen gegen unberechtigtes Lösen
                        gesichert.
                        Wir setzen bei unseren Handläufen Verbindungsrohre aus V2A- Edelstahl als Kraft-und
                        Lastenüberträger
                        ein und achten auf Kraft- und Formschluss.
                    </p>
                </div>
              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Edelstahlschraubenn_6er_und_8er.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>

              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Oehringen_Bild-30.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                    <h2>Pfostenschuhe</h2>
                    <p>
                        Wir verwenden Pfostenschuhe in der Dimensionierung Ø 133 x 4,5 mm, Länge 110/120 cm aus
                        verzinktem Stahlrundrohr mit 2 Luftzirkulationsschlitzen für die
                        optimale Abtrocknung des Holzes. Die durchgehende Dreifachverschraubung sorgt zusammen mit dem
                        30er Armierungsrohr für die statische Haltbarkeit. Durch die
                        Verwendung von Rundrohren, die geschlitzt werden (keine Halbschalen) bietet der Pfostenschuh
                        hervorragende statische Eigenschaften, die natürlich gutachterlich belegt sind. Die Optik des
                        gesamten Standpfostens wirkt harmonisch, da keine Kanten bzw. Rohrwandungen hervorstehen und
                        bietet gleichzeitig einen konstruktiven Holzschutz, da Wasser, welches am Pfosten herabrinnt,
                        sich nicht zwischen Rohr und Stamm sammelt.
                        Dieses System bewährt sich seit über 25 Jahren!
                    </p>
                </div>

                <div class="lg:col-span-3">
                    <h2>Standpfosten aus Aluminium</h2>
                    <p>
                        Wir haben unsere Standpfosten überarbeitet und optimiert. So bieten wir Ihnen diese je nach
                        statischen Erfordernissen auch aus Aluminium-Rundrohr an. Der Durchmesser beträgt 140 mm, die
                        Wandung ist 5 mm stark! Die Standpfosten sind grundsätzlich pulverbeschichtet (Standard ist
                        Platingrau, RAL 7036). Unsere Aluminiumpfosten entsprechen der EN AW-6060 und haben eine
                        Witterungsbeständigkeit von 1 (sehr gut) und eine Seewasserbeständigkeit von 2 (gut).
                    </p>
                    <p>
                        Belastungsversuche und geprüfte Statik nach DIN EN 1176:-1:2017-12 bestätigen hervorragende
                        konstruktive Festigkeit sowohl in der Belastung des gesamten Standpfostens im Verbau als auch in
                        der Belastung von Schraubverbindungen durchgehend und mittels Nietmuttern.
                    </p>
                </div>
              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C0808.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>

              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C2379.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                    <h2>HPL-Dächer und Brüstungen</h2>
                    <p>
                        HPL-Hochdruckschichtstoffe (High Pressure Laminate) bestehen aus mehreren Schichten Kern- und
                        Dekorpapieren, die mit Phenol- bzw. Melaminharzen imprägniert und unter Wärmeeinwirkung
                        miteinander verpresst werden. Dieses Oberflächenmaterial ist extrem belastbar, kann nicht
                        aufquellen und ist UV-stabil. Wir verwenden HPL-Platten für Brüstungen und Dächer.
                    </p>
                    <p class="font-bold">
                        Lebensmittelecht und schwer entflammbar!
                    </p>
                </div>

                <div class="lg:col-span-3">
                    <h2>Böden aus HC-Strukturplatte</h2>
                    <p>
                        Unsere HC-Strukturplatte besteht aus vielen Lagen Zellulose-Papier, die mit Phenolharz getränkt
                        sind. Diese werden dann in speziellen Formen unter Hochdruck und Wärmezufuhr zu Platten mit 15
                        mm Stärke gepresst. Die rutschhemmende Oberfläche wird bereits beim Pressvorgang gestaltet.
                    </p>
                    <p>
                        Durch die geometrische Struktur und das Material erreichen wir eine Rutschhemmklasse R11 gemäß
                        DIN 51130: 2014. Zudem nimmt die Platte keine Feuchtigkeit auf und kann nicht aufquellen!
                        Rutschfest, lebensmittelecht und schwer entflammbar!
                    </p>
                </div>
              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C85961.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>

              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C5272.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                    <h2>Seile und Netze</h2>
                    <p>
                        Unsere Kletternetze und Hangeltaus bestehen aus 1,6 cm bzw. 2,0 cm starken Polypropylenseilen
                        (Herkulesmaterial). Die Litzen sind umlegt in den Farben rot, blau, gelb und grün. In der
                        Variante „Rustikal“ kommen auch beige und schwarze Taue zum Einsatz. Das Seil ist 4-litzig und
                        hat eine 4-fach Stahleinlage von ca. 0,3 mm Ø, Bruchkraft 3900 daN. Die Knotenverbindungen
                        erfolgt durch Knotenkugeln mit einer Fixierungsschraube oder gesteckten Maschen.
                    </p>
                    <p>
                        Die Seile sind einzeln austauschbar!
                    </p>
                </div>
            </div>
        </section>

        <section
            class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
            style="background-image: url(/images/backgrounds/BQ4C1421-1.jpg);"
        >
          <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" flip variant="trio"/>
          </div>
          <span class="brand-overlay is-duo is-reversed is-vertical noprint"/>
            <div class="relative z-10 py-48 dp-pagebounds">
              <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                    Wir bringen Farbe ins Spiel
                </h2>
            </div>
          <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" variant="trio"/>
          </div>
        </section>

        <section class="container">
            <div class="grid lg:grid-cols-5 gap-12">
                <div class="lg:col-span-3">
                    <h2>Holz im Außenbereich</h2>
                    <p>
                        Durch einen Anstrich mit OSMO Farbe erhält Holz Schutz vor UV-Strahlung und vor Regen/
                        Feuchtigkeit, das heißt vor Umwelt- und Witterungseinflüssen. OSMO Anstriche bieten
                        physikalischen Holzschutz.
                    </p>
                </div>
              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Oehringen_Bild-73.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>

              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C6125.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                    <h2>Metall pulverbeschichtet im Außenbereich</h2>
                    <p>
                        Der Stellenwert der Pulverbeschichtung nimmt in vielen Bereichen der Bauwirtschaft ständig zu,
                        da es sich um ein gegenüber dem Nasslackieren sehr umweltfreundliches und haltbares Verfahren
                        handelt. Durch die systembedingte höhere Schichtstärke ergibt sich eine große Beständigkeit
                        gegenüber mechanischer Beanspruchung.
                    </p>
                </div>

                <div class="lg:col-span-3">
                    <h2>HPL Melaminharzplatten</h2>
                    <p>
                        Unsere Melamini-Spielgeräte (HPL) bringen Farbe in Ihre Spielwelt. Durch die in die Oberfläche
                        einlaminierte Farbschicht, strahlt HPL auch nach der Entfernung von Graffiti wieder in altem
                        Glanz. Wer das Material kennt, weiß, dass es so gut wie keine Einschränkung für Form und Farbe
                        gibt. Es ist zudem extrem stoß-, schlag- und wasserfest. Der Clou: Sollte es wirklich einmal
                        ausgedient haben, kann man es anstandlos in Industriefeueranlagen verbrennen oder über den
                        Hausmüll entsorgen.
                    </p>
                </div>
              <div class="lg:col-span-2 rounded-lg overflow-hidden drop-shadow-lg">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C8961.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
            </div>
        </section>

        <section class="theme-group bg-secondary py-12 space-y-12">
            <div class="container flex flex-col lg:flex-row gap-8 justify-center">
              <HexagonImage :to="{name: 'playgrounds'}" additional-class="lg:w-1/4" img-src="BQ4C0483.jpg" title="Spiellandschaften"/>
              <HexagonImage :to="{name: 'slides'}" additional-class="lg:w-1/4" img-src="BQ4C2038-1.jpg" title="Rutschen"/>
              <HexagonImage :to="{name: 'melamini'}" additional-class="lg:w-1/4" img-src="BQ4C8964.jpg" title="Melamini"/>
              <HexagonImage :to="{name: 'climbing'}" additional-class="lg:w-1/4" img-src="BQ4C6158_neu.jpg" title="Kletterstrecken"/>
            </div>
            <div class="container flex flex-col lg:flex-row gap-8 justify-center">
              <HexagonImage :to="{name: 'waterFacilities'}" additional-class="lg:w-1/4" img-src="Wasserspiel1.jpg" title="Wasserspielanlagen"/>
              <HexagonImage :to="{name: 'metall'}" additional-class="lg:w-1/4" img-src="junge-auf-seilbruecke-serie-metall-4-0.png" title="Metall 4.0"/>
            </div>
        </section>

        <section class="container">
            <div class="grid lg:grid-cols-3 gap-12">
                <!--
                                <NuxtLink
                                    v-for="(pdf, index) in pdfDownloads"
                                    :key="index"
                                    class="cursor-pointer duration-200 hover:scale-105"
                                    @click="downloadFile(pdf.file, pdf.title)"
                                >
                -->
                <NuxtLink
                    v-for="(pdf, index) in pdfDownloads"
                    :key="index"
                    class="cursor-pointer duration-200 hover:scale-105"
                    :href="pdf.file"
                    target="_blank"
                >
                    <UCard class="h-full bg-black/10">
                        <template #header>
                            <div class="flex justify-center bg-white p-2 shadow-md">
                                <NuxtPicture
                                    :src="pdf.image"
                                    :alt="pdf.title"
                                    class="w-1/3"
                                />
                            </div>
                        </template>
                        <template #default>
                          <h3 class="text-secondary!">
                                {{ pdf.title }}
                            </h3>
                            <p>{{ pdf.type }} | {{ pdf.size }}</p>
                            <button class="flex! gap-2 button bordered">
                                <IconDownload/>
                                Herunterladen
                            </button>
                        </template>
                    </UCard>
                </NuxtLink>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
import IconDownload from '~/components/Icons/IconDownload.vue';

definePageMeta({
    path: '/Material',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Materialien',
};

const {gtag} = useGtag();

const sectionIntro = {
    images: ['BQ4C1710.jpg', 'Öhringen_Bild-%2873%29.jpg', 'BQ4C5188.jpg'],
    title: 'Entdecken Sie unser Material',
    teaser: 'Bei Sauerland Spielgeräte werden ausschließlich hochwertige Materialien erstklassig verarbeitet.',
    text: '<p>Die Vielfalt unserer Materialien ist riesig. Von Schrauben und Verbindungen, über Netze und Seile bis hin zu Aluminium und Strukturplatten. Hier finden Sie sicherlich das richtige Material für Ihren gewünschten Spielplatz.</p>',
};

const pdfDownloads = ref([{
    title: 'Einleitung',
    file: '/pdf/Einleitung.pdf',
    image: 'Einleitung.png',
    type: 'PDF',
    size: '6,34 MB',
}, {
    title: 'Materialbeschreibung-Kletterstrecken',
    file: '/pdf/Materialbeschreibung-Kletterstrecken.pdf',
    image: 'Materialbeschreibung-Kletterstrecken.png',
    type: 'PDF',
    size: '3,26 MB',
}, {
    title: 'Aluminiumpfosten',
    file: '/pdf/Aluminiumpfosten.pdf',
    image: 'Aluminiumpfosten.png',
    type: 'PDF',
    size: '1,12 MB',
}, {
    title: 'Farbübersicht',
    file: '/pdf/Farbuebersicht.pdf',
    image: 'Farbuebersicht.png',
    type: 'PDF',
    size: '3,35 MB',
}, {
    title: 'Rutschen und Wellenrutschen',
    file: '/pdf/Rutschen-und-Wellenrutschen.pdf',
    image: 'Rutschen-und-Wellenrutschen.png',
    type: 'PDF',
    size: '2,18 MB',
}, {
    title: 'Kleinkindgeräte Revision 19-04-2024',
    file: '/pdf/Kleinkindgeraete_Revision_19-04-2024.pdf',
    image: 'Kleinkindgeraete_Revision_19-04-2024.png',
    type: 'PDF',
    size: '2,26 MB',
}, {
    title: 'Materialbeschreibung Jupiter',
    file: '/pdf/Materialbeschreibung-Jupiter.pdf',
    image: 'Materialbeschreibung-Jupiter.png',
    type: 'PDF',
    size: '2,50 MB',
}]);

function gaEventPdf(pdfUrl: string) {
    gtag('event', 'conversion', {send_to: 'AW-428666490/7sivCObz46oDEPrcs8wB'});
    gtag('event', 'select_content', {
        content_type: 'Website pdf',
        content_id: pdfUrl,
    });
}

async function downloadFile(link: string, title: string) {
    const fileName = title + '.pdf';
    const {data} = await useFetch<Blob | MediaSource>(link, {
        method: 'get',
        body: null,
        responseType: 'blob',
    });

    if (data.value) {
        const fileURL = window.URL.createObjectURL(data.value);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(fileURL);// Clean up

        gaEventPdf(link);
    }
}
</script>

<style scoped>

</style>
